import React, { Component } from "react";
import ContactCenterResumen, {
  ProcesoResultado
} from "../../../../types/ContactCenterResumen";

interface Props {
  resumen: ContactCenterResumen[];
}

export default class GeneracionContactCenterTable extends Component<Props> {
  getRowStyle = (resultado: ProcesoResultado) => {
    switch (resultado) {
      case ProcesoResultado.ERROR:
        return { backgroundColor: "#f8d7da" };
      case ProcesoResultado.WARNING:
        return { backgroundColor: "#fffbdbff" };
      default:
        return {};
    }
  };

  formatCurrency = (value: number) => {
    return new Intl.NumberFormat("es-MX", {
      style: "currency",
      currency: "MXN"
    }).format(value || 0);
  };

  formatPercent = (value: number) => {
    return `${(value || 0).toFixed(2)}%`;
  };

  render() {
    const { resumen } = this.props;

    if (!resumen || resumen.length === 0) {
      return null;
    }

    return (
      <>
        <div className="mb-4">
          <div className="row">
            <div className="col-12">
              <h5>Resumen de Comisiones Contact Center</h5>
              <p className="text-muted">
                Total de empleados procesados: {resumen.length}
              </p>
            </div>
          </div>

          <div className="row mt-3">
            <div className="col-12">
              <div className="table-responsive">
                <table className="table table-striped table-bordered table-sm">
                  <thead className="thead-dark">
                    <tr>
                      <th rowSpan={2}>No. Empleado</th>
                      <th rowSpan={2}>Nombre</th>
                      <th rowSpan={2}>Tipo</th>
                      <th colSpan={5} className="text-center">
                        Citas Confirmadas
                      </th>
                      <th colSpan={7} className="text-center">
                        Conversiones
                      </th>
                      <th rowSpan={2}>Total Comisión</th>
                      <th rowSpan={2}>Mensaje</th>
                    </tr>
                    <tr>
                      <th>Meta</th>
                      <th>Captadas</th>
                      <th>Alcance %</th>
                      <th>Comisión</th>
                      <th>Total</th>
                      <th>Meta</th>
                      <th>Integrantes</th>
                      <th>Ventas</th>
                      <th>Reactivación</th>
                      <th>Total Conv.</th>
                      <th>Alcance %</th>
                      <th>Bono</th>
                    </tr>
                  </thead>
                  <tbody>
                    {resumen.map((emp, i) => (
                      <tr key={i} style={this.getRowStyle(emp.resultado)}>
                        <td>{emp.numeroEmpleado}</td>
                        <td>{emp.empleadoNombre}</td>
                        <td>{emp.esSupervisor ? "Supervisor" : "Chater"}</td>

                        <td>{emp.metaCitas || 0}</td>
                        <td>{emp.citasCaptadas || 0}</td>
                        <td>{this.formatPercent(emp.citasAlcance)}</td>
                        <td>{this.formatCurrency(emp.citaComision)}</td>
                        <td>
                          <strong>
                            {this.formatCurrency(emp.citaComisionTotal)}
                          </strong>
                        </td>

                        <td>{emp.metaConversion || 0}</td>
                        <td>{emp.integrantes || 0}</td>
                        <td>{emp.ventas || 0}</td>
                        <td>{emp.reactivacion || 0}</td>
                        <td>{emp.conversiones || 0}</td>
                        <td>{this.formatPercent(emp.conversionAlcance)}</td>
                        <td>{this.formatCurrency(emp.conversionBono)}</td>

                        <td>
                          <strong className="text-success">
                            {this.formatCurrency(emp.totalComision)}
                          </strong>
                        </td>
                        <td>{emp.mensaje || emp.descripcion}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}
